import(/* webpackMode: "eager" */ "/vercel/path0/gondola-web-app/node_modules/next/dist/client/link.js");
